import React, { useEffect } from 'react';
import styles from './styles';
import { RBHAlert, RBHBox, RBHError, RBHTable, RBHText, RBHTextInput } from '../../../../shared/components';
import { Breadcrumb, Empty, Menu, Tag } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import styleText from '../../../../shared/components/rbh-text/styles';
import styleInput from '../../../../shared/components/rbh-textinput/styles';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import { ExclamationCircleFilled, FilterFilled, PushpinOutlined, SearchOutlined } from '@ant-design/icons';
import metrics from '../../../../shared/theme/metrics';
import { MainHelper } from '../../../main-helper';
import { BRANCH_STATE_KEY, branchStateSelector } from '../redux/branch-reducer';
import { branchCreators } from '../redux/branch-action';
import { Colors } from '../../../../shared/theme';
import './stylescss.css';
import { httpCreators, useLoadingSelector } from '@ppvrbh/merchant-frontend-core';
import { UtilHelper } from '../../../../shared/helpers/utility';
import { posSagas } from './redux/pos-saga';
import { PosService } from './redux/pos-service';
import { POS_REQUEST_ID_LIST, POS_STATUS } from './redux/pos-constant';
import { BRANCH_REQUEST_ID_LIST } from '../redux/branch-constant';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY, generalStateSelector } from '../../../../redux/general/general-reducer';
import { DEFAULT_PAGE_SIZE, MODAL_TYPE } from '../../../../redux/general/general-constant';
import { Branch } from '../../../../shared/models/branch';
import { posCreators } from './redux/pos-action';
import { POS_STATE_KEY, posStateSelector } from './redux/pos-reducer';

export const PosManagementScreen: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const alertCancelPosSuccess = useSelector(posStateSelector(POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS));
  const alertCancelPosFail = useSelector(posStateSelector(POS_STATE_KEY.ALERT_CANCEL_POS_FAIL));
  const alertDeactivatePosSuccess = useSelector(posStateSelector(POS_STATE_KEY.ALERT_DEACTIVATE_POS_SUCCESS));
  const alertDeactivatePosFail = useSelector(posStateSelector(POS_STATE_KEY.ALERT_DEACTIVATE_POS_FAIL));
  const branchData = useSelector(branchStateSelector(BRANCH_STATE_KEY.BRANCH_LIST)) as [];
  const loading = useLoadingSelector(BRANCH_REQUEST_ID_LIST.GET_BRANCH);
  const branchStatusCode = MainHelper.getMasterDataByScheme('ShopStatus');
  const lang = useSelector(generalStateSelector(GENERAL_STATE_KEY.LOCALE));
  

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
    reload();
  }, []);

  const reload = () => {
    dispatch(branchCreators.callBranch());
  };

  const toPosStep = (step: number) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push(`/main/posmanagement/step${step + 1}`);
  };

  const toAddFoodMenu = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/addmenu');
  };

  const checkIsActivatePos = (shopData: Branch) => {
    reload();
    posDetailPopup(shopData);
  };

  const getPosCurrentStep = (shopData: Branch) => {
    dispatch(httpCreators.request({
      id: POS_REQUEST_ID_LIST.GET_POS_CURRENT_STEP,
      sagaHandler: posSagas.getPosCurrentStepHandler as any,
      callbackParams: { toPosStep, shopData, toAddFoodMenu, checkIsActivatePos },
      service: PosService.getPosCurrentStep,
      serviceParams: shopData.shopId
    }));
  };

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(branchCreators.callBranch());
  };

  const onMenuItemClick = (setSelectedKeys: any, selectedKeys: any, confirm: any, clearFilters: any, value: any) => {
    if (selectedKeys[0] === value) {
      clearFilters();
    } else {
      setSelectedKeys([value]);
      confirm();
    }
  };

  const posDetailPopup = (shopData: Branch) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalListContent: shopData,
      type: MODAL_TYPE.POS_DETAIL
    }));
  };

  const posStatusRender = (tagId: string, linkId: string, value: any, all: any) => {
    if (value === POS_STATUS.PS01) {
      return (
        <RBHBox>
          <Tag id={tagId} style={styles.tagPs01}>
            <FormattedMessage id={'main.posManagement.landing.posStatus.tag.ps01'} />
          </Tag>
          <RBHText data-testid={linkId} id={linkId} style={styles.posStatusLink}
            onClick={() => getPosCurrentStep(all)} text={'main.posManagement.landing.posStatus.link.ps01'} />
        </RBHBox>
      );
    } else if (value === POS_STATUS.PS02) {
      return (
        <RBHBox>
          <Tag id={tagId} style={styles.tagPs02}>
            <FormattedMessage id={'main.posManagement.landing.posStatus.tag.ps02'} />
          </Tag>
          <RBHText data-testid={linkId} id={linkId} style={styles.posStatusLink}
            onClick={() => getPosCurrentStep(all)} text={'main.posManagement.landing.posStatus.link.ps02'} />
        </RBHBox>
      );
    } else if (value === POS_STATUS.PS03 && !all.isActivate && all.posStartDate !== null) {
      return (
        <RBHBox>
          <Tag id={tagId} style={styles.tagPs03withDate}>
            <FormattedMessage id={'main.posManagement.landing.posStatus.tag.ps03.withDate'}
              values={{ date: all.posStartDate ? UtilHelper.formatFullDate(all.posStartDate, lang) : undefined }} />
          </Tag>
          <RBHText data-testid={linkId} id={linkId} style={styles.posStatusLink}
            onClick={() => getPosCurrentStep(all)} text={'main.posManagement.landing.posStatus.link.ps03.withDate'} />
        </RBHBox>
      );
    } else if (value === POS_STATUS.PS03 && all.isActivate) {
      return (
        <RBHBox>
          <Tag id={tagId} style={styles.tagPs03noDate}>
            <FormattedMessage id={'main.posManagement.landing.posStatus.tag.ps03.noDate'} />
          </Tag>
          <RBHText data-testid={linkId} id={linkId} style={styles.posStatusLink}
            onClick={() => posDetailPopup(all)} text={'main.posManagement.landing.posStatus.link.ps03.noDate'} />
        </RBHBox>
      );
    } else if (value === POS_STATUS.PS04) {
      return (
        <RBHBox>
          <Tag id={tagId} style={styles.tagPs04}>
            <ExclamationCircleFilled translate={null} style={{ color: Colors.white }} />
            <FormattedMessage id={'main.posManagement.landing.posStatus.tag.ps04'} />
          </Tag>
          <RBHText data-testid={linkId} id={linkId} style={styles.posStatusLink}
            onClick={() => getPosCurrentStep(all)} text={'main.posManagement.landing.posStatus.link.ps04'} />
        </RBHBox>
      );
    }
  };

  const columns = [
    {
      width: metrics.tableHeader.width160,
      title: <FormattedMessage id={'main.branchtable.branchname'} />,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => {
        return (
          <RBHBox style={styles.searchBox}>
            <RBHTextInput
              placeholder={'main.branchtable.addbranchname'}
              data-testid={'search-branch-input'}
              id={'search-branch-input'}
              style={styleInput.inputTableSearch}
              value={selectedKeys[0]}
              onChange={(e: any) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={confirm}
              onBlur={confirm}
            />
          </RBHBox>
        );
      },
      filterIcon: (filtered: any) => (
        <SearchOutlined data-testid={'search-branch-icon'} id={'search-branch-icon'}
          translate={null} style={{ color: filtered ? Colors.lightPurple : undefined }} />
      ),
      onFilter: (value: any, all: any) => {
        return all.shopName.toString().toLowerCase().includes(value.toLowerCase());
      },
      onFilterDropdownVisibleChange: (visible: boolean) => {
        if (visible) {
          setTimeout(() => {
            const inputEl = document.getElementById('search-input');
            if (inputEl) {
              (inputEl as HTMLInputElement).select();
            }
          });
        }
      },
      render: (value: any, all: any, index: number) => {
        const shopNameId = 'id-shopName-' + index;
        const branchCode = 'id-branchCode-' + index;
        return (
          <RBHBox style={{ maxWidth: metrics.tableHeader.width160 }}>
            <RBHText data-testid={shopNameId} id={shopNameId} style={styleText.textRegular12}>{all.shopName}</RBHText>
            <RBHText data-testid={branchCode} id={branchCode}
              style={styles.textRegular12Gray}>{all.branchCode}</RBHText>
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width60,
      title: <FormattedMessage id={'main.branchtable.shopId'} />,
      dataIndex: 'shopId',
      render: (value: any, all: any, index: number) => {
        const shopId = 'shopId-' + index;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width60 }} data-testid={shopId} id={shopId}>
            {value}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width160,
      title: <FormattedMessage id={'main.branchtable.branchaddress'} />,
      dataIndex: 'address',
      render: (value: any, all: any, index: number) => {
        const latLongId = 'id-latLong-' + index;
        const addressId = 'id-address-' + index;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width160 }}>
            <RBHBox data-testid={addressId} id={addressId}>
              {value.addressDetail} {value.addressSubdistrict} {value.addressDistrict} {value.addressProvince} {value.addressPostalCode}
            </RBHBox>
            <RBHBox data-testid={latLongId} id={latLongId}>
              {all.shopStatus === branchStatusCode[0] ?
                <RBHBox style={styleText.textTableContentPurple}><PushpinOutlined translate={null} />
                  {' '}{all.shopLatitude}{','}{all.shopLongitude}</RBHBox>
                : <RBHBox><PushpinOutlined translate={null} />{' '}{all.shopLatitude}{','}{all.shopLongitude}</RBHBox>}
            </RBHBox>
          </RBHBox>);
      }
    },
    {
      width: metrics.base * 11,
      className: 'branchstatus-filter',
      title: <FormattedMessage id={'main.branchtable.branchstatus'} />,
      dataIndex: 'shopStatus',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => {
        return (
          <Menu style={styleText.textTableContent} selectable={false}>
            {
              branchStatusCode.map((code: string) => {
                return (
                  <Menu.Item
                    key={code}
                    id={code}
                    data-testid={code}
                    style={selectedKeys[0] === code ? styles.selectedMenuItem : {}}
                    onClick={() => onMenuItemClick(setSelectedKeys, selectedKeys, confirm, clearFilters, code)}
                  >
                    {MainHelper.getMasterDataByCode(code)}
                  </Menu.Item>
                );
              })
            }
          </Menu>
        );
      },
      filterIcon: (filtered: any) => (
        <FilterFilled data-testid={'filter-status-icon'} id={'filter-status-icon'}
          translate={null} style={{ color: filtered ? Colors.lightPurple : undefined }} />
      ),
      onFilter: (value: boolean, all: any) => {
        return all.shopStatus === value;
      },
      render: (value: any, all: any, index: number) => {
        const closeStatusText = value === 'SS02' ?
          all.nextOpenDateTime ? <FormattedMessage id={'main.branchtable.willOpen'}
            values={{ date: UtilHelper.formatFullDate(all.nextOpenDateTime, lang) }} />
            : all.nextOpenDateTime === null ? <FormattedMessage id={'main.branchtable.closedIndefinitely'} /> : '' : '';
        const indexId = 'id-branch-status-' + index;
        return <span style={{ width: metrics.base * 11 }} data-testid={indexId}
          id={indexId}>{MainHelper.getMasterDataByCode(value)}{closeStatusText}</span>;
      }
    },
    {
      width: metrics.tableHeader.width100,
      align: 'left',
      title: <FormattedMessage id={'main.posManagement.landing.table.posStatus'} />,
      dataIndex: 'posStatus',
      render: (value: any, all: any, index: number) => {
        const tagId = `posStatus-tag-${index}`;
        const linkId = `posStatus-link-${index}`;
        const posStatusBox = `posStatus-box-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width100 }} data-testid={posStatusBox} id={posStatusBox}>
            {posStatusRender(tagId, linkId, value, all)}
          </RBHBox>
        );
      }
    }
  ];

  setTimeout(() => {
    if (alertCancelPosSuccess) {
      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS, false));
    } else if (alertCancelPosFail) {
      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_FAIL, false));
    } else if (alertDeactivatePosSuccess) {
      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_DEACTIVATE_POS_SUCCESS, false));
    } else if (alertDeactivatePosFail) {
      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_DEACTIVATE_POS_FAIL, false));
    }
  }, 3000);

  const isAlert = () => {
    if (alertCancelPosSuccess) {
      return (
        <RBHBox id={'cancelPos-alert-success'} data-testid={'cancelPos-alert-success'}>
          <RBHAlert type={'success'} text={'main.posManagement.landing.alert.cancelPos.success'}
            afterClose={() => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS, false))} /><br />
        </RBHBox>
      );
    } else if (alertCancelPosFail) {
      return (
        <RBHBox id={'cancelPos-alert-fail'} data-testid={'cancelPos-alert-fail'}>
          <RBHAlert type={'error'} text={'main.posManagement.landing.alert.cancelPos.fail'}
            afterClose={() => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_FAIL, false))} /><br />
        </RBHBox>
      );
    } else if (alertDeactivatePosSuccess) {
      return (
        <RBHBox id={'deactivatePos-alert-success'} data-testid={'deactivatePos-alert-success'}>
          <RBHAlert type={'success'} text={'main.posManagement.landing.alert.deActivatePos.success'}
            afterClose={() => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_DEACTIVATE_POS_SUCCESS, false))} /><br />
        </RBHBox>
      );
    } else if (alertDeactivatePosFail) {
      return (
        <RBHBox id={'deactivatePos-alert-fail'} data-testid={'deactivatePos-alert-fail'}>
          <RBHAlert type={'error'} text={'main.posManagement.landing.alert.deActivatePos.fail'}
            afterClose={() => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_DEACTIVATE_POS_FAIL, false))} /><br />
        </RBHBox>
      );
    }
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'posmanagement-tohomepage-breadcrumb'}
              id={'posmanagement-tohomepage-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => {
                history.push('/main');
              }}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'branchmanagement-breadcrumb'}
              id={'branchmanagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => {
                history.push('/main/branchmanagement');
              }}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'posManagement-breadcrumb'}
              id={'posManagement-breadcrumb'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.posManagement.landing.posManagement'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const headerRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid={'posManagement-title'} id={'posManagement-title'}
          style={styleText.headerText} text={'main.posManagement.landing.posManagement'} />
      </RBHBox>
    );
  };

  const headerDesc = () => {
    return (
      <RBHBox style={styles.textDesc}>
        <RBHText data-testid={'posManagement-desc1'} id={'posManagement-desc1'}
          style={styleText.formText} text={'main.posManagement.landing.headerDesc.text1'} />&nbsp;
        <a data-testid={'posManagement-desc2'} id={'posManagement-desc2'}
          href='https://www.robinhood.co.th/th/food/merchant/pos-instruction' target='_blank' style={styles.regularPurple14under}>
          <FormattedMessage id={'main.posManagement.landing.headerDesc.text2'} />
        </a>
      </RBHBox>
    );
  };

  const tableRender = () => {
    return (
      <RBHBox style={styles.defaultContent}>
        <RBHTable
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<span> <FormattedMessage id={'main.table.notFound'} /> </span>} />
          }}
          rowClassName={(record: any) => {
            if (record.shopStatus !== branchStatusCode[0]) {
              return 'disabled';
            }
            return '';
          }}
          rowKey={'shopId'}
          columns={columns}
          dataSource={branchData}
          pagination={{
            showSizeChanger: false,
            pageSize: DEFAULT_PAGE_SIZE,
            position: ['bottomLeft'],
            hideOnSinglePage: true,
            showTotal: (total: number, range: number[]) => {
              return (
                <RBHText style={styleText.textPaginationShowTotal}>
                  <FormattedMessage id={'main.showing'} />
                  <span data-testid={'id-bottom-rage-page'}
                    id={'id-bottom-rage-page'}> {range[0] + '-' + range[1]} </span>
                  <FormattedMessage id={'main.of'} />
                  <span data-testid={'id-bottom-total-page'} id={'id-bottom-total-page'}> {total}</span>
                </RBHText>
              );
            }
          }}>
        </RBHTable>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      {isAlert()}
      {BreadcrumbRender()}
      {loading ? null :
        <RBHBox>
          {headerRender()}
          {headerDesc()}
          {branchData === undefined || branchData.length < 1 ?
            <RBHError onOk={() => resetReload()} />
            :
            <RBHBox style={styles.paddingTop20}>
              {tableRender()}
              <RBHText data-testid={'posManagement-remark'} id={'posManagement-remark'} style={styles.remarkTextRegular14Gray}
                text={'main.posManagement.landing.remark'} />
            </RBHBox>
          }
        </RBHBox>
      }
    </RBHBox>
  );
};

type Props = {};
